import { InteractionEvent } from 'pixi.js';
import { DEFAULT_BUTTON_OPTIONS } from '../constant';
import { ButtonOptions } from '../interface';
import TextFrame from './TextFrame';

class Button extends TextFrame {
  public options: ButtonOptions;
  private pressed: boolean;

  constructor(options?: Partial<ButtonOptions>) {
    super({ ...DEFAULT_BUTTON_OPTIONS, ...(options || {}) });

    this.options = { ...DEFAULT_BUTTON_OPTIONS, ...(options || {}) };
    this.interactive = true;
    this.buttonMode = true;
    this.pressed = false;
  }

  public pointerdown(e: InteractionEvent): void {
    this.pressed = true;
    this.x += this.width * 0.025;
    this.y += this.height * 0.025;
    this.scale.set(this.scale.x * 0.95);
  }

  public pointerup(e: InteractionEvent): void {
    if (this.pressed) {
      this.scale.set(this.scale.x / 0.95);
      this.x -= this.width * 0.025;
      this.y -= this.height * 0.025;
      this.pressed = false;
      this.emit('_pointerup', e);
    }
  }

  public pointerupoutside(e: InteractionEvent): void {
    this.scale.set(this.scale.x / 0.95);
    this.x -= this.width * 0.025;
    this.y -= this.height * 0.025;
    this.pressed = false;
  }
}

export default Button;
